import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import TotalSummary from "./totalSummary";
import HourlyTotalSummary from "./hourlyTotalSummary";
import DailySummary from "./dailySummary";
import HourlySummary from "./hourlySummary";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import { Table, Button } from "react-bootstrap";
import HighlightedDetailTab from "../../commoncomponents/highlightedDetailTab";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import queryString from "query-string";

class AssetRunningSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: "Select start date",
      calendarSelect: false,
      calendarSelect2: false,
      dataPlaceholder2: "Select end date",
      calendarStartDate: new Date(),
      calendarEndDate: new Date(),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: new Date(),
      globalDate: [],
      endDate: new Date(),
      calendarShow: false,
      calendarShow2: false,
      checked: true,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      isLoading:false
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.assetId) {
      console.log("AssetId from Realtime ", values.assetId);
      console.log("Assetname from Realtime ", values.EndDate);
      console.log("assetDate from Realtime ", values.SearchDate);
      if (values.SearchDate) {
        await this.setState({
          dataPlaceholder: moment(values.SearchDate).format(
            "dddd Do MMMM, YYYY"
          ),
          ReportDate: values.SearchDate,
        });
      }
      if (values.EndDate) {
        await this.setState({
          dataPlaceholder2: moment(values.EndDate).format(
            "dddd Do MMMM, YYYY"
          ),
          endDate: values.EndDate,
        });
      }
      await this.setState({
        assetPlaceholder: values.assetName,
        assetId: values.assetId,
      });
      this.handleCreateReport();
    }
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ groupDetails: GroupList.data });
      console.log("group details", GroupList.data);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  getAssets = async () => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if(AssetList.status===200)
      {
        this.setState({isLoading:false, AssetList: AssetList.data.paggedlist, assetLoader: false  });
      }
      else {
        this.setState({isLoading:true });
      }

      // this.setState({
      //   AssetList: AssetList.data.paggedlist,
      //   assetLoader: false,
      // });
      console.log("group details", AssetList.data.paggedlist);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, id) => {
    this.setState({ assetLoader: true });
    this.groupId = id;
    this.setState({
      groupId: id,
      groupCustomerName: customer,
      groupGeneralName: name,
      assetCustomerName: "",
      assetGeneralName: "",
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    console.log(customer, name);
    this.getAssets();
  };
  handleAssetSelection = (asset, name, id) => {
    this.setState({
      assetId: id,
      assetCustomerName: asset,
      assetGeneralName: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
    });
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    console.log("daateeeee", date);
    console.log("clicked date mvtl", moment(date).format("YYYY-MM-DD"));
    this.setState({
      calendarSelect: true,
      calendarStartDate: date,
      globalDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  calendarFunction2 = () => {
    if (this.state.globalDate != "") {
      this.setState({
        calendarShow2: !this.state.calendarShow2,
      });
    } else {
      alert("select start date");
    }
  };
  onChangeDate2 = (date) => {
    console.log("end date", date);
    this.setState({
      calendarSelect2: true,
      calendarEndDate: date,
      endDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleCheckup = () => {
    console.log(this.state.checked);
    this.setState({
      checked: !this.state.checked,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };
  handleCreateReport = async () => {
    this.setState({
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      // generatedDate:moment().format("DD-MMM hh:mm a")
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/AssetSummary`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: this.state.checked,
          EndDate: this.state.endDate,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      console.log("group details", ReportDetails);
      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  render() {
    const GroupTable = (
      <div
        className={
          this.state.groupTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        <Table striped responsive hover>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupDetails.map((item, index) => {
              return (
                <tr
                  className="trRow"
                  title="click to select"
                  id="1"
                  onClick={(e) =>
                    this.handleGroupSelection(
                      item.customername,
                      item.groupName,
                      item.groupId
                    )
                  }
                >
                  <td>{item.customername}</td>
                  <td>{item.groupName}</td>
                  <td>{item.description}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );

    const AssetTable = (
      <div
        className={
          this.state.assetTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        {!this.state.isLoading && this.state.AssetList.length > 0 ? (
          <Table striped hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.AssetList.map((item, index) => {
                return (
                  <tr
                    className="trRow"
                    title="click to select"
                    id="1"
                    onClick={(e) =>
                      this.handleAssetSelection(
                        item.name,
                        item.customerName,
                        item.assetId
                      )
                    }
                  >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.statusId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : this.state.isLoading && (
          <AssetInforWarning
            warningText={true}
            warningTextMsg=" No assets found"
          />
        )}
      </div>
    );

    const data = (
      <div
        className={
          this.state.assetShow
            ? "dropDownContainer smoothHeight"
            : "dropDownContainer"
        }
      >
        {this.state.groupDetails != "" ? (
          <div className="dropDownContentMainContainer">
            <div className="dropDownHeading">
              {this.state.groupTabHeading ? (
                <h1>1. Select Group</h1>
              ) : (
                <HighlightedDetailTab
                  leftIcon="fa-th"
                  functionCall={this.toggleGroupTable}
                  click={this.state.groupTabHighlight}
                  customerName={this.state.groupCustomerName}
                  generalName={this.state.groupGeneralName}
                  count="114"
                />
              )}
            </div>
            <div className="dropDownContent">
              {GroupTable}
              {/* {this.state.groupTabHighlight?
                  :""
                } */}
            </div>
            <br />
            {this.state.groupId != "" ? (
              <div>
                <div className="dropDownHeading">
                  {this.state.assetTabHeading ? (
                    <h1>2. Select Asset</h1>
                  ) : (
                    <HighlightedDetailTab
                      leftIcon="fa-truck"
                      click={this.state.assetTabHighlight}
                      functionCall={this.toggleAssetTable}
                      customerName={this.state.assetCustomerName}
                      generalName={this.state.assetGeneralName}
                      count="34"
                    />
                  )}
                </div>
                {!this.state.assetLoader ? (
                  <div className="dropDownContent">{AssetTable}</div>
                ) : (
                  <center>
                    <br />
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.assetLoader}
                    />
                    <br />
                  </center>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="dropDownFooter">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  this.setState({ assetShow: false });
                }}
              >
                Cancel
              </Button>
              &nbsp;
              {this.state.assetCustomerName != "" &&
              this.state.groupGeneralName != "" ? (
                <Button
                  onClick={() => {
                    this.setState({
                      assetShow: false,
                      assetPlaceholder: this.state.assetCustomerName,
                    });
                  }}
                  variant="success"
                >
                  OK
                </Button>
              ) : (
                <Button variant="success" disabled>
                  OK
                </Button>
              )}
            </div>
          </div>
        ) : (
          <center>
            <br />
            <GridLoader size={7} color={"#222222"} loading={true} />
            <br />
          </center>
        )}
      </div>
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            //  minDate={moment(this.state.globalDate[0]).subtract(3, 'months').toDate()}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(3, "months").toDate() >
              new Date()
                ? new Date()
                : moment(this.state.globalDate).add(3, "months").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    return (
      <Layout>
        <Helmet>
          <title>Asset Running Summary</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <div className="headingContainer">
              <h2 className="mainHeading">
                Asset Running Summary <span>v2.0.6</span>
              </h2>
              <i
                className={
                  this.props.headerHide
                    ? `fa fa-window-restore`
                    : `fa fa-window-maximize`
                }
                onClick={this.handleWindow}
              />
            </div>
            <hr />
            <div className="inputFormGroup">
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.truckFunction}
                  dropDown={data}
                  placeholder={this.state.assetPlaceholder}
                  icon="fa-truck"
                />
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction}
                  dropDown={calendarReport}
                  placeholder={this.state.dataPlaceholder}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
              {console.log("placeholderrrr",this.state.dataPlaceholder2)}
                <ReportButtonGroup
                  function={this.calendarFunction2}
                  dropDown={calendarReport2}
                  placeholder={this.state.dataPlaceholder2}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                <p>
                  <input
                    type="checkbox"
                    onChange={this.handleCheckup}
                    checked={this.state.checked}
                  ></input>{" "}
                  Use Filtering{" "}
                </p>
                {this.state.assetCustomerName != "" &&
                this.state.calendarSelect &&
                this.state.calendarSelect2 ? (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                ) : (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                )}
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <div className="loaderLine">
                    <h1>Something Went Wrong...!</h1>
                  </div>
                ) : (
                  <React.Fragment>
                    <TotalSummary reportDetails={this.state.reportDetails}
                        assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}

                    />

                    <HourlyTotalSummary
                      reportDetails={this.state.reportDetails}
                      assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}
                    />

                    {this.state.reportDetails != "" && (
                      <DailySummary
                        reportDetails={this.state.reportDetails}
                        assetId={this.state.assetId}
                        SearchDate={this.state.ReportDate}
                        UseFiltering={this.state.checked}
                        assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}
                      />
                    )}

                    {this.state.reportDetails != "" && (
                      <HourlySummary
                        reportDetails={this.state.reportDetails}
                        assetId={this.state.assetId}
                        SearchDate={this.state.ReportDate}
                        UseFiltering={this.state.checked}
                        assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}
                      />
                    )}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
        {/* <div className="contentBody">
              <div className="contentWrapper">


       <TotalSummary/>

            <HourlyTotalSummary/>


<DailySummary/>

        <HourlySummary/>

              </div>
            </div> */}
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetRunningSummary);
